import { Component, OnInit, Input, ViewChildren, ElementRef, AfterViewInit, Renderer2, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

// Classes.
import { Article } from '../../classes/article';


@Component({
  selector: 'app-article',
  templateUrl: './article.component.html',
  styleUrls: ['./article.component.scss']
})
export class ArticleComponent implements OnInit, AfterViewInit {

  @Input() article: Article;

  @ViewChild('articleContent', { static: false }) content: ElementRef;

  constructor(private router: Router, private renderer: Renderer2) { }

  ngOnInit() { }

  /**
   * {@inheritdoc}
   *
   * @memberof ArticleComponent
   */
  ngAfterViewInit() {
    const linksData: HTMLCollection = this.content.nativeElement ? this.content.nativeElement.querySelectorAll('[data-link]') : undefined;
    if (linksData) {
      Array.from(linksData)
        .forEach((codeBlock): void => {
          // listen for button click event
          this.renderer.listen(codeBlock, 'click', (ev) => {
            const id = codeBlock.getAttribute('data-link');
            //this.renderer.setAttribute(codeBlock, 'data-link', '');
            if (id.toString() !== this.article.id.toString()) {
              const queryParam =
                codeBlock.textContent.includes('Book')
                  || codeBlock.textContent.includes('Appendix')
                  || codeBlock.textContent.includes('Chapter') ?
                  codeBlock.textContent :
                  this.article.parents[this.article.parents.length - 2].label;
              this.router.navigate(['rulebook/article/', id], { fragment: 'article-' + id, queryParams: { book_title: queryParam } });
            }
          });

        });
    }
  }

}
